import { CategoryTypeEnum } from 'app-components/flux/categories/categoriesTypes';
import { useField } from 'app-components/flux/categories/categoryFormHooks';
import QChoiceTextField from 'components/QuickenControls/QChoiceChips/QChoiceTextField';
import React from 'react';

const initialCap = (value: string) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
const items = [CategoryTypeEnum.INCOME, CategoryTypeEnum.EXPENSE].map((name) => initialCap(name));

const TaxInfoType = ({ parentType }: { parentType?: string }) => {
  const { value: type, onValueChange } = useField('type');

  const displayValue = initialCap(type);

  return (
    <QChoiceTextField
      text='Type'
      QChoiceChipsProps={{
        items,
        selectedItems: [displayValue],
        onSelected: (items) => onValueChange(items[0].toUpperCase() as CategoryTypeEnum),
        disabled: !!parentType,
      }}
    />
  );
};

export default TaxInfoType;
